import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"
import { useClickOutside } from "stimulus-use"
import { useHotkeys } from "stimulus-use/hotkeys"

// Connects to data-controller="dropdown"
export default class extends Controller {
  
  static targets = ["container", "menu"]
  
  static values = {
    placement: String,
    offset: String,
    strategy: { type: String, default: "absolute" }
  }

  static classes = ["hidden"]

  connect() {
    useClickOutside(this)
    useHotkeys(this, { "escape": [this.hide] })
    
    this.popperInstance = createPopper(this.element, this.containerTarget, {
      placement: this.placementValue,
      strategy: this.strategyValue,
      modifiers: [
        { name: "offset", options: { offset: [0, this.offsetValue ?? 8] } }
      ]
    })
  }

  toggle() {
    this.menuTarget.classList.contains("hidden") ? this.show() : this.hide()
  }

  show() {
    this.menuTarget.classList.remove(...this.hiddenClasses)
    this.popperInstance.update()
  }

  hide() {
    this.menuTarget.classList.add(...this.hiddenClasses)
    this.popperInstance.update()
  }
  
  clickOutside() {
    this.hide()
  }
  
  disconnect() {
    this.popperInstance && this.popperInstance.destroy()
  }

}
